'use strict';
angular.module('smartorg.r6.navs.menu').directive("rangalMenu", ["shareLink", "$rootScope", function (shareLink, $rootScope) {
        return {
            restrict: 'E',
            template: require('../../template/menu.html'),
            transclude: true,
            scope: {
                selectedTreeNode: "=",
                menus: "=",
                menuTitle: "@",
                menuLoaded: "=",
                isAdmin: "@",
                smartorg: "=?",
                selectedMenuItem: "=",
                showClusterMenu: "=",
                onSelectAction: "&",
                downloadModelToggle: "="
            },
            link: function (scope) {
                // if (!scope.showClusterMenu) {
                //     scope.showClusterMenu = {
                //         name: undefined
                //     };
                // }
                // scope.$watch('showClusterMenu.name', (newVal, oldVal) => {
                //     console.log(newVal, oldVal);
                // });
                scope.$watch('selectedTreeNode', function (newVal) {
                    if (newVal) {
                        var nodeId = newVal._id;
                        scope.smartorg.getUserPrivilege(nodeId).then(function (res) {
                            // PORTFOLIO_ADMIN = 3
                            // CONTRIBUTOR = 2
                            // OBSERVER = 1
                            // NO_ACCESS = 0
                            scope.userPrivilege = res;
                            scope.smartorg.getUserGroupDownloadModel().then(function (canDownload) {
                                scope.groupDownloadModel = canDownload;
                            })["catch"](function (err) {
                                console.error(err);
                            });
                        })["catch"](function (err) {
                            console.error(err);
                        });
                    }
                });
                scope.clusterClick = function (menuItem) {
                    // Cluster menus do not have id.
                    // They use display name as id.
                    if (scope.showClusterMenu.name == menuItem.name) {
                        scope.showClusterMenu.name = undefined;
                    }
                    else {
                        scope.showClusterMenu.name = menuItem.name;
                    }
                };
                scope.menuClick = function (menuItem) {
                    if ($rootScope.smartorgDirty) {
                        var discardChange = confirm("The unsaved data will be lost. Do you want to proceed?");
                        if (discardChange) {
                            $rootScope.smartorgDirty = false;
                        }
                        else {
                            return;
                        }
                    }
                    scope.selectedMenuItem = menuItem;
                    scope.$emit('selectedMenu', { 'node': menuItem });
                    shareLink.setValue("menu", menuItem.menuID);
                    // Hackily hide popovers.
                    // TODO: Make it less hacky.
                    var pops = $('[data-toggle="popover"]');
                    pops.popover('hide');
                    scope.onSelectAction({
                        nodeID: menuItem.nodeID,
                        menuID: menuItem.menuID,
                        command: menuItem.Command
                    });
                };
                scope.initUniversal = function () {
                    scope.onSelectAction({
                        nodeID: undefined,
                        menuID: undefined,
                        command: "UNIVERSAL_OUTPUT_NEW"
                    });
                };
                scope.showAlert = function (type, title, message) {
                    scope.$emit('workbench:alert', { type: type, title: title, message: message });
                };
                scope.downloadSpreadsheet = function () {
                    scope.smartorg.getUserGroupDownloadModel().then(function (canDownload) {
                        if (canDownload) {
                            scope.onSelectAction({
                                nodeID: undefined,
                                menuID: undefined,
                                command: "DOWNLOAD_SPREADSHEET"
                            });
                        }
                        else {
                            scope.showAlert("warning", "Warning", "No download model permission for current group users.");
                        }
                    })["catch"](function (err) {
                        console.error(err);
                    });
                };
            }
        };
    }]);
//# sourceMappingURL=menu-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/menu/app/js/plumbing/menu-directive.js